<template lang="pug">
  server-data(
    :method="(params) => $api.courses.index(params, serviceType)"
    #default="{ serverData, loading }"
  )
    select-list-course(
      :items="serverData"
      :loading="loading"
      v-on="$listeners"
    )
</template>

<script>
import { COURSE_SERVICE } from '@/modules/CourseManagement/constants';

import SelectListCourse from './SelectListCourse.vue';

export default {
  components: {
    SelectListCourse,
  },
  props: {
    serviceType: { type: Number, default: COURSE_SERVICE.all },
  },
};
</script>
